import { createTheme } from '@mui/material/styles';
import { divertilandiaColors } from './divertilandiaColors';

// Tema personalizado de Divertilandia con colores del arcoíris
export const divertilandiaTheme = createTheme({
  palette: {
    primary: {
      main: divertilandiaColors.rainbow.blue,
      light: '#7BB3FF',
      dark: '#2E7CE8',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: divertilandiaColors.rainbow.green,
      light: '#8DD99B',
      dark: '#4AB85F',
      contrastText: '#FFFFFF',
    },
    success: {
      main: divertilandiaColors.rainbow.green,
      light: '#8DD99B',
      dark: '#4AB85F',
    },
    warning: {
      main: divertilandiaColors.rainbow.yellow,
      light: '#FFE066',
      dark: '#E6C235',
    },
    error: {
      main: divertilandiaColors.rainbow.red,
      light: '#FF8A8A',
      dark: '#E55555',
    },
    info: {
      main: divertilandiaColors.rainbow.indigo,
      light: '#B199FB',
      dark: '#7C5DFA',
    },
    background: {
      default: '#FAFAFA',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#2C3E50',
      secondary: '#7F8C8D',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      color: divertilandiaColors.standard.primary,
    },
    h2: {
      fontWeight: 600,
      color: divertilandiaColors.standard.primary,
    },
    h3: {
      fontWeight: 600,
      color: divertilandiaColors.standard.info,
    },
    h4: {
      fontWeight: 600,
      color: divertilandiaColors.standard.primary,
    },
    h5: {
      fontWeight: 500,
      color: divertilandiaColors.standard.secondary,
    },
    h6: {
      fontWeight: 500,
      color: divertilandiaColors.standard.accent,
    },
  },
  components: {
    // Personalización de botones
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: 'none',
          fontWeight: 600,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          },
        },
        contained: {
          background: divertilandiaColors.gradients.primary,
          '&:hover': {
            background: divertilandiaColors.gradients.primary,
            filter: 'brightness(1.1)',
          },
        },
        outlined: {
          borderWidth: 2,
          '&:hover': {
            borderWidth: 2,
          },
        },
      },
    },
    // Personalización de cards
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          border: '1px solid rgba(255,255,255,0.2)',
          '&:hover': {
            boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
            transform: 'translateY(-2px)',
            transition: 'all 0.3s ease-in-out',
          },
        },
      },
    },
    // Personalización de chips
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          fontWeight: 600,
        },
        colorPrimary: {
          background: divertilandiaColors.rainbow.blue,
          color: 'white',
        },
        colorSecondary: {
          background: divertilandiaColors.rainbow.green,
          color: 'white',
        },
      },
    },
    // Personalización de paper
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
        elevation1: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        },
        elevation2: {
          boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
        },
        elevation3: {
          boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
        },
      },
    },
    // Personalización de tabs
    MuiTabs: {
      styleOverrides: {
        indicator: {
          background: divertilandiaColors.gradients.rainbow,
          height: 4,
          borderRadius: 2,
        },
      },
    },
    // Personalización de tab
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          '&.Mui-selected': {
            color: divertilandiaColors.rainbow.blue,
          },
        },
      },
    },
    // Personalización de app bar
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: divertilandiaColors.gradients.primary,
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        },
      },
    },
    // Personalización de drawer
    MuiDrawer: {
      styleOverrides: {
        paper: {
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
        },
      },
    },
    // Personalización de list items
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          margin: '4px 8px',
          '&:hover': {
            background: 'rgba(255,255,255,0.1)',
          },
          '&.Mui-selected': {
            background: 'rgba(255,255,255,0.2)',
            '&:hover': {
              background: 'rgba(255,255,255,0.25)',
            },
          },
        },
      },
    },
  },
});

export default divertilandiaTheme;
